// packages/web/src/components/ui/Card.tsx — misma API + `description` opcional.
import type { ReactNode } from 'react';

interface Props {
  title?: string;
  description?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Card({ title, description, actions, children, className = '' }: Props) {
  return (
    <section className={`bg-white rounded-xl border border-slate-200 p-5 space-y-4 ${className}`}>
      {(title || actions) && (
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            {title && <h2 className="text-base font-semibold text-slate-900">{title}</h2>}
            {description && <p className="text-sm text-slate-600 mt-0.5">{description}</p>}
          </div>
          {actions && <div className="flex shrink-0 gap-2">{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}
